let key = {};
// if (process.env.NODE_ENV === "production") {
if (process.env.REACT_APP_MODE === "production") {
  console.log("Set Production Config");
  const API_URL = "https://Ferzanapi.alwin.io/";
  // const API_URL = 'http://52.206.15.203';
  //const API_URL = 'http://localhost';
  key = {
    // baseUrl: `${API_URL}:2053`,
    baseUrl: `${API_URL}`,
    Front_URL: "https://Ferzancontrols.alwin.io",
  };
} else if (process.env.REACT_APP_MODE === "development") {
  console.log("Set Development Config");
  const API_URL = "https://ferzanapi.wearedev.team";

  key = {
    // baseUrl: `${API_URL}:2053`,
    baseUrl: `${API_URL}`,
    Front_URL: "https://ferzan-adminwallet.pages.dev",
  };
} else {
  console.log("Set Local Config");
  // const API_URL = 'http://52.206.15.203' ;          //'http://localhost';
  const API_URL = "http://localhost:3507";
  key = {
    baseUrl: `${API_URL}`,
    Front_URL: "https://Ferzancontrols.alwin.io",
  };
}

export default key;
